// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages90_root__3xpQu","title":"AfterImages90_title__2PMCw","images":"AfterImages90_images__3VpiS"};